import angular from 'angular';
import { ConfigService } from '../../shared/config/config.service';
import { EFeatures } from '../../src/app/@shared-types/tenant/enums';

/* @ngInject */
export class TierService {
  private configService: ConfigService;

  constructor(
    configService: ConfigService,
  ) {
    'ngInject';

    this.configService = configService;
  }

  public authorizedToUseFeature = (feature: EFeatures): boolean => {
    const features = this.configService.get<EFeatures[]>('featuresForTenant');
    if (!features) return false;

    return features.includes(feature);
  };
}

export default angular.module('services.tierService', [])
  .service('tierService', TierService)
  .name;
